<style scoped lang="scss" type="text/scss">
    .group-photos-wrap {
        float: left;
        width: 100%;

        .group-photos {
            display: flex;
            flex-wrap: wrap;
            margin-top: 1rem;
            overflow: auto;

            .group-photo {
                height: 15rem;
                margin: 1rem 0 0 1rem;
            }
        }
    }

    @media screen and (max-width: 95rem) {
        .group-photo {
            &:nth-child(-n + 3) {
                margin-top: 0 !important;
            }

            &:nth-child(3n - 2) {
                margin-left: 0 !important;
            }

            width: calc((100% - 2rem) / 3);
        }
    }

    @media screen and (min-width: 95rem) {
        .group-photo {
            &:nth-child(-n + 4) {
                margin-top: 0 !important;
            }

            &:nth-child(4n - 3) {
                margin-left: 0 !important;
            }

            width: calc((100% - 3rem) / 4);
        }
    }
</style>

<template>
    <div class="group-photos-wrap">
        <div class="group-photos" :style="{'max-height': visualAreaHeight}">
            <placeholder class="placeholder" v-if="players.length === 0">
                尚未有参赛队上传合照
            </placeholder>
            <group-photo-item class="group-photo"
                              v-for="(player, index) in players" :key="index" :info="player">
            </group-photo-item>
        </div>
    </div>
</template>

<script>
    import infoPanel from '../../../../../components/info-panel/index';
    import Placeholder from '../../../../../components/placeholder/index';
    import GroupPhotoItem from './group-photo-item';
    import {handlePlayers} from '../../../../../utils/data-handler';
    import _ from 'lodash';

    export default {
        name: '',
        components: {
            infoPanel,
            Placeholder,
            GroupPhotoItem
        },
        data () {
            return {
                players: [],
                requesting: false
            };
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            },
            visualAreaHeight () {
                const height = this.$store.getters['layout/adminPlayerInformationOverviewVisualAreaHeight'];
                if (height === null) return null;
                return +height + 'px';
            }
        },
        watch: {
            currentCompetitionId: {
                immediate: true,
                handler (id) {
                    if (id === null || id === undefined) return;
                    this.loadPlayersByCompetitionId(id);
                }
            }
        },
        methods: {
            loadPlayersByCompetitionId (id) {
                this.$normalRequest('player/loadPlayersByCompetitionId', {
                    competition_id: id
                }, false, false, this, 'requesting').then(data => {
                    this.players = handlePlayers(_.filter(data, item => item.group_photo !== null));
                });
            }
        }
    };
</script>
